import { HANDOFF_LANG_KEY } from '../hooks/usePrefilledAddress';
import { isPortalI18nActive, portalLanguage } from '../i18n';

export type BookingLang = 'en' | 'fr' | 'es';

const LANGS: BookingLang[] = ['en', 'fr', 'es'];

const normalise = (value?: string | null): BookingLang | undefined => {
  const code = (value || '').trim().slice(0, 2).toLowerCase() as BookingLang;
  return LANGS.includes(code) ? code : undefined;
};

/**
 * The language the visitor is booking in: the language on screen when the
 * portal runs its translations (Aperio); otherwise the marketing-site hand-off
 * (`lang=` on the booking URL, remembered in sessionStorage), else the
 * document language, else the browser's. Never throws - storage can be
 * blocked in a private window.
 */
export function getBookingLang(): BookingLang {
  // The portal's own language when it runs translations (Aperio preset).
  if (isPortalI18nActive()) return portalLanguage();
  let stored: string | null = null;
  try {
    stored = window.sessionStorage.getItem(HANDOFF_LANG_KEY);
  } catch {
    stored = null;
  }
  return (
    normalise(stored)
    || normalise(
      typeof document !== 'undefined' ? document.documentElement.lang : '',
    )
    || normalise(typeof navigator !== 'undefined' ? navigator.language : '')
    || 'en'
  );
}
